import { makeStyles } from '@material-ui/core/styles';

import { CARD, KICKER, PILL_PRIMARY, PILL_SECONDARY, TEXT_LINK } from '../Home/HomeDashboard/dashboardStyles';
import { COLORS2, REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

// Styles the profile page's panels share.
const useProfileStyles = makeStyles(() => ({
    card: {
        ...CARD,
        padding: 'clamp(22px, 2.8vw, 32px)',
    },
    kicker: {
        ...KICKER,
        marginBottom: '6px',
    },
    cardTitle: {
        margin: '0 0 8px',
        fontSize: '1.2rem',
        letterSpacing: '-0.02em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    text: {
        margin: '0 0 16px',
        color: REDESIGN_COLORS.body,
        fontSize: '0.95rem',
        lineHeight: 1.6,
    },
    actions: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '12px',
    },
    primary: {
        ...PILL_PRIMARY,
        minHeight: '48px',
    },
    secondary: {
        ...PILL_SECONDARY,
        minHeight: '48px',
    },
    danger: {
        ...PILL_SECONDARY,
        minHeight: '48px',
        borderColor: 'rgba(243, 83, 37, 0.4)',
        color: COLORS2.virtualRed,
        '&:hover': {
            borderColor: COLORS2.virtualRed,
            color: COLORS2.virtualRed,
        },
    },
    link: TEXT_LINK,
    rule: {
        height: '1px',
        margin: '22px 0',
        background: REDESIGN_COLORS.sand,
    },
    note: {
        margin: 0,
        color: REDESIGN_COLORS.muted,
        fontSize: '0.88rem',
        fontWeight: 600,
    },
    // Inline notices, in place of MUI alerts.
    notice: {
        margin: '0 0 16px',
        padding: '12px 16px',
        borderRadius: '14px',
        fontSize: '0.92rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
    },
    noticeOk: {
        color: REDESIGN_COLORS.dark,
        background: REDESIGN_COLORS.mist,
        border: `1px solid ${REDESIGN_COLORS.primaryBorderSoft}`,
    },
    noticeError: {
        color: COLORS2.virtualRed,
        background: 'rgba(243, 83, 37, 0.08)',
        border: '1px solid rgba(243, 83, 37, 0.3)',
    },
    // Form field, as on the contact page.
    field: {
        display: 'grid',
        gap: '6px',
    },
    label: {
        color: REDESIGN_COLORS.dark,
        fontSize: '0.86rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
    },
    input: {
        boxSizing: 'border-box',
        width: '100%',
        minHeight: '50px',
        padding: '12px 16px',
        border: `1px solid ${REDESIGN_COLORS.line}`,
        borderRadius: '14px',
        background: REDESIGN_COLORS.cream,
        fontFamily: REDESIGN_FONTS.body,
        fontSize: '1rem',
        fontWeight: 600,
        color: REDESIGN_COLORS.dark,
        outline: 'none',
        '&::placeholder': {
            color: REDESIGN_COLORS.muted,
            fontWeight: 500,
            opacity: 1,
        },
        '&:focus': {
            borderColor: REDESIGN_COLORS.primary,
            boxShadow: '0 0 0 3px rgba(16, 169, 179, 0.15)',
        },
        '&:disabled': {
            color: REDESIGN_COLORS.muted,
        },
    },
    // A checkbox row on the cream surface.
    check: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        padding: '14px 16px',
        border: `1px solid ${REDESIGN_COLORS.line}`,
        borderRadius: '14px',
        background: REDESIGN_COLORS.cream,
        color: REDESIGN_COLORS.dark,
        fontSize: '0.95rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
        lineHeight: 1.45,
        cursor: 'pointer',
        '& input': {
            flexShrink: 0,
            width: '20px',
            height: '20px',
            marginTop: '1px',
            accentColor: REDESIGN_COLORS.primary,
        },
    },
}));

export default useProfileStyles;
